<h2 mat-dialog-title>Vælg login metode</h2>
<mat-dialog-content>
  <p>Der er flere måder at logge ind med denne bruger. Vælg venligst en:</p>
  <div class="auth-methods">
    @for (method of data.methods; track method) {
    <button
      mat-raised-button
      (click)="selectMethod(method)"
      class="auth-method-button"
    >
      {{ method.name }}
      <!--<small *ngIf="method.description">{{ method.description }}</small>-->
    </button>
    }
  </div>
</mat-dialog-content>
